import React from 'react';
import PropTypes from 'prop-types';
import { domToReact } from 'html-react-parser';
import findDomElement, { findDomElementFilterFn, findDomElements } from '../../../../findDomElement';
import GenericHeroWithImage from '../../../../../components/Atoms/GenericHeroWithImage/GenericHeroWithImage';
import { idAttribute, altLabel } from './Constants';
import { Tags } from '../toTypography/Constants';

export const getCleanFirstChildData = (element) => element?.firstChild?.data?.replace(/[\n]?/g, '')?.trim();
const filterByClassName = (className) => (element) => element?.attribs?.class?.includes(className);

const toCtaBanner = (parserData) => 
{
    const { parserOptions: {replaceFn} } = parserData;

    const Wrapper = ({ name = '', type = '', attribs = {}, children }) => 
    {   
        if (type !== 'tag') return null;
        if (!name || name !== 'section') return null;
        if (!attribs?.id) return null;
        if (attribs.id !== idAttribute) return null;

        const imgContainer = findDomElementFilterFn({ 
            element: children?.filter(child => child.type === "tag")?.at(0), 
            filterFn: filterByClassName('cdm-ornamental-image-block') 
        })

        const imgFound = findDomElements({ element: imgContainer, targetName: 'pre' });
        const ilustration = imgFound?.filter(img => img?.attribs?.type === "application/json")?.at(0);
        const foundIcon = findDomElement({ element: children?.filter(child => child.type === "tag")?.at(0), targetName: 'img' }) 
        const foundSingleCtaTitle = findDomElementFilterFn({ 
            element: children?.filter(child => child.type === "tag")?.at(0), 
            filterFn: filterByClassName('wp-block-cdm-customizations-posttitle') 
        });

        const styleObject = attribs?.style ? attribs.style.split(';').reduce((acc, style) =>
        {
            if (style.trim())
            {
                const [key, value] = style.split(':').map(item => item.trim());
                if (key && value) acc[key] = value;
            }
            return acc;
        }, {}) : {};

        const foundDescription = findDomElement({ element: children?.filter(child => child.type === "tag")?.at(0), targetName: 'p' })
        const anchors = findDomElements({ 
            element: children.filter(child => child.type === "tag")?.at(0), targetName: 'a' 
        })

        const buttons = anchors.filter(anchor => anchor?.attribs?.class?.includes("ql-ctabutton-link")).map(anchor => 
        {
            const svg = findDomElement({ element: anchor, targetName: 'svg' });

            return {
                href: anchor.attribs.href,
                buttonText: anchor?.children?.[0].children?.[0].data,
                buttonIcon: svg ? domToReact([svg], replaceFn()) : undefined,
                buttonClasses: anchor.attribs.class,
                buttonAttributes: {
                    target: anchor.attribs.target
                }
            }
        })

        let image = false;
        let altText = false;
        
        if (ilustration)
        {
            image = JSON.parse(ilustration?.firstChild?.data);
            altText = image?.alt || altLabel;  
        }

        if (foundIcon && !ilustration && foundIcon?.attribs?.src)
        {
            image = foundIcon.attribs.src;
            altText = foundIcon.attribs?.alt || altLabel;
        }

        return <GenericHeroWithImage
            title={getCleanFirstChildData(foundSingleCtaTitle?.children[0])}
            headline={Tags.find(item => item.tag === foundSingleCtaTitle?.children[0]?.name)}
            image={image}
            description={foundDescription?.children[0].data || ''}
            backgroundColor={styleObject || ''}
            buttons={buttons}
            imgAlt={altText}
            {...parserData}
        />;
    };

    Wrapper.propTypes = {
        name: PropTypes.oneOf(['div']),
        type: PropTypes.oneOf(['tag']),
        attribs: PropTypes.shape({
            class: PropTypes.string,
            id: PropTypes.string
        }),
        children: PropTypes.arrayOf(PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object
        ])),
    };

    return Wrapper;
};

export default toCtaBanner;
